import {FormattedMessage, IntlShape} from "react-intl";
import {Form} from "react-bootstrap";

import Page from "../../components/page";
import {PageProps} from "../../components/page/page-view";
import Table from "./table";
import {TableColumns} from "./table/table-view";

import "./my-licenses.scss";
import ProgressIndicator from "../../components/progress-indicator/progress-indicator-container";
export enum UILicenseStatus {
  DISABLED= "disabled",
  EXPIRED= "expired",
  EXPIRING="expiring",
  SCHEDULED="scheduled",
  VALID="valid",
  INVALID="invalid"
}
export interface UILicense {
  id: string;
  name: string|undefined;
  isValid: boolean;
  category: string|undefined;
  validFrom: string|undefined;
  validUntil: string|undefined;
  link?: string[]|undefined;
  status: UILicenseStatus;
}
export interface MyLicensesReduxProps {
  userId: string|undefined;
  licenses: UILicense[] | { [category: string]: UILicense[]} |undefined,
  onLoadLicenses: (userId:string) => void,
  isReady: boolean,
}
export interface MyLicensesProps extends
    Omit<PageProps, "children">,
    MyLicensesReduxProps
{
  showAll: boolean|{[category:string]:boolean},
  onSetShowAll: (b: boolean|{[category:string]:boolean}) => void,
  columnRenderers: TableColumns<UILicense>,
  categories: string[]|undefined;
  intl: IntlShape;
}
function rowClassResolver(d:UILicense) {
  return d.status;
}
function MyLicenses(props: MyLicensesProps) {
  const {
    intl,
    licenses,
    auth,
    showAll,
    onSetShowAll,
    columnRenderers,
    categories,
      isReady,
  } = props;
  return <Page
      className={"My-licenses"}
      meta={{
        title: intl.formatMessage({
          defaultMessage: "My licenses",
          description: "window meta title for the my licenses page",
        }),
        description: intl.formatMessage({
          defaultMessage: "List of users licenses",
          description: "window meta description for the my licenses page",
        }),
      }}
      auth={auth}
  >
    <header>
      <h1>
        <FormattedMessage
            defaultMessage="{userName} ({userEmail}) licenses"
            description="Page heading for the my licenses page. 'userName' = display name of the user, 'userEmail' = email address"
            values={{
              userName: auth?.userDisplayName,
              userEmail: auth?.userEmail
            }}
        />
      </h1>
    </header>
    <div>
      {!categories?.length && (<>
        <Form.Check
            type={"switch"}
            label={
              <FormattedMessage
                  defaultMessage="Show only valid licenses"
                  description="Label for filter toggle that controls visibility of invalid licenses in table"
              />
            }
            id={"my-licenses-showAll"}
            checked={!showAll}
            onChange={() => onSetShowAll(!showAll)}
            value="1"
        />
        <Table<UILicense>
            data={licenses as UILicense[] || []}
            colKeys={Object.keys(columnRenderers)}
            columnRenderers={columnRenderers}
            rowClassResolver={rowClassResolver}
        />
      </>)}
      {categories?.length && categories?.map((c) => (<section key={c} className={"category " + c}>
          <header>
            <div className={"copy"}>
              <h2>
                <FormattedMessage
                    defaultMessage="{category, select, other {{category}}}"
                    description="heading for optional categories. 'category' = customer defined additional category info. {category, select, other {{category}}} prints the name of category, inject ' value {translated value} ' between the 'select,' and 'other' to override and translate categories."
                    values={{
                      category: c
                    }}
                />
              </h2>
              <p>
              <FormattedMessage
                  defaultMessage="{category, select, other {}}"
                  description="lead paragraph for optional categories. 'category' = customer defined additional category info. {category, select, other {}} prints no text what so ever, inject ' value {translated value} ' between the 'select,' and 'other' to override and translate categories."
                  values={{
                    category: c
                  }}
              />
              </p>
            </div>
            <Form.Check
                type={"checkbox"}
                label={
                  <FormattedMessage
                      defaultMessage="Show only valid licenses"
                      description="Label for filter toggle that controls visibility of invalid licenses in table"
                  />
                }
                id={"my-licenses-showAll" + c}
                checked={!(showAll as { [category: string]: boolean })[c]}
                onChange={() => onSetShowAll({
                  ...(showAll as { [category: string]: boolean }),
                  [c]: !(showAll as { [category: string]: boolean })[c]})}
                value="1"
            />
          </header>
          <Table<UILicense>
              category={c}
              colKeys={Object.keys(columnRenderers)}
              data={licenses ? (licenses as { [category: string]: UILicense[] })[c] as UILicense[] : []}
              columnRenderers={columnRenderers}
              rowClassResolver={rowClassResolver}
          />
      </section>))}
    </div>
    <ProgressIndicator show={!isReady} variant={'lg'} backdrop={true} />
  </Page>
}
export default MyLicenses;
